module.exports = __webpack_public_path__ + "img/thumb_aula43.392b18a8.jpg";